import(/* webpackMode: "eager" */ "/var/www/lumi/apps/studio/src/app/global-error.tsx");
